import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classnames from 'classnames';

import 'styles/Link.scss';

const ReduxLink = (props) => {
  const { iconName, to = '_', isDisabled, isActive, path, ...otherProps } = props; //eslint-disable-line no-unused-vars

  const className = classnames(
    'Link',
    {
      'link-icon': !!iconName,
      'is-disabled': isDisabled,
      [`icon-${iconName}`]: !!iconName,
      [otherProps.activeClassName]: isActive
    }
  );

  return (
    <Link to={to} {...otherProps} className={className} />
  );
};

ReduxLink.propTypes = {
  iconName: PropTypes.string,
  path: PropTypes.string,
  isDisabled: PropTypes.bool,
  isActive: PropTypes.bool,
  to: PropTypes.string
};

export default connect(
  (state, ownProps) => {
    const prevLocation = state.routing.locationBeforeTransitions;

    return {
      ...ownProps,
      path: prevLocation ? prevLocation.pathname : ''
    };
  }, () => ({})
)(ReduxLink);



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Link/index.js
 **/